

export default [
   
    {
        path: "subscription-products",
        name: "SubscriptionProducts",
        component: () =>
            import(
                /* webpackChunkName: "developersApiKeys" */ "@/views/general/settings/roadcubeMarket/tabs/SubscriptionProducts.vue"
            )
    },

    {
        path: "attributes",
        name: "Attributes",
        component: () =>
            import(
                /* webpackChunkName: "developersWebhooks" */ "@/views/general/settings/roadcubeMarket/tabs/Attributes.vue"
            )
    },
    

    {
        path: "attribute-options",
        name: "AttributeOptions",
        component: () =>
            import(
                /* webpackChunkName: "developersWebhookResponses" */ "@/views/general/settings/roadcubeMarket/tabs/AttributeOptions.vue"
            )
    },
    

    {
        path: "variants",
        name: "Variants",
        component: () =>
            import(
                /* webpackChunkName: "developersWebhookLogs" */ "@/views/general/settings/roadcubeMarket/tabs/Variants.vue"
            )
    },

    {
        path: "shop",
        name: "Shop",
        component: () =>
            import(
                /* webpackChunkName: "developersWebhookLogs" */ "@/views/general/settings/roadcubeMarket/tabs/Shop.vue"
            )
    },

];
